export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/format/number.js
// module id = 65
// module chunks = 1